/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { PureComponent, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import StoreLeftMenu from '../../menu/StoreLeftMenu';
import Footer from '../../components/Footer';

import StoreComment from './StoreComment';
import StoreList from './StoreList';
import parse from 'html-react-parser';

import StoreEdit from './StoreEdit';
import { toast } from 'react-toastify'; //토스트(toast)
import { confirmAlert } from 'react-confirm-alert';
// import $ from "jquery";

class StoryItem extends PureComponent {
  state = {
    edit: false,
    isLike: 0,
    likes: 0,
  };
  _isLoad = false;
  componentDidMount = () => {
    this._isLoad = true;
    const { match } = this.props;
    const store = match.params.store;
    const idx = match.params.idx;
    //console.log(idx, store)
    this._getData(parseInt(idx), store);
  };
  componentWillUnmount = () => {
    this._isLoad = false;
  };

  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    ////console.log(this.props.location.pathname)
    ////console.log(nextProps.location)

    return this.props.match.params.idx !== nextProps.match.params.idx;
    //return true;
  };
  componentWillReceiveProps = (nextProps) => {
    if (this.props.match.params.idx !== nextProps.match.params.idx) {
      this._getData(
        parseInt(nextProps.match.params.idx),
        nextProps.match.params.store
      );
    }
  };
  _getData = async (idx, store) => {
    const result = await this._getDataApi(idx, store);
    const intReturn = result.data[0].intReturn;
    const storeContent = result.data[0].listData;

    window.scrollTo(0, 0);
    if (intReturn === 0) {
      if (this._isLoad) {
        this.setState({
          storeContent,
          isLike: storeContent[0].isLike,
          likes: storeContent[0].likes,
        });
      }
    }
  };
  _getDataApi = (idx, store) => {
    const { apiUrl, loginId } = this.props;
    return axios
      .post(apiUrl + '/storyDetailNew', {
        params: {
          board_id: 301,
          idx: idx,
          store: store,
          userid: loginId,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };
  _back = () => {
    const { history } = this.props;
    history.goBack();
  };
  _edit = () => {
    const { loginId } = this.props;
    // const idx = match.params.idx;

    if (
      loginId === 'admin' ||
      loginId === 'dlrhrjs33' ||
      loginId === 'lsy7414' ||
      loginId === 'dooyu63' ||
      loginId === 'xwuuwx' ||
      loginId === 'aji311' ||
      loginId === 'animi15' ||
      loginId === 'yoonyg00'
    ) {
      if (this._isLoad) {
        this.setState({
          edit: true,
        });
      }
    }

    //console.log(idx)
    //history.push('/storeEdit/'+ idx)
  };
  _editCancel = () => {
    if (this._isLoad) {
      this.setState({
        edit: false,
      });
    }
  };
  _editSuccess = () => {
    const { match } = this.props;
    const store = match.params.store;
    const idx = match.params.idx;
    if (this._isLoad) {
      this.setState({
        edit: false,
      });

      this._getData(parseInt(idx), store);
    }
  };
  _del = async () => {
    const { loginId } = this.props;
    // const idx = match.params.idx;
    if (
      loginId === 'admin' ||
      loginId === 'dlrhrjs33' ||
      loginId === 'lsy7414' ||
      loginId === 'dooyu63' ||
      loginId === 'xwuuwx' ||
      loginId === 'aji311' ||
      loginId === 'animi15' ||
      loginId === 'yoonyg00'
    ) {
      confirmAlert({
        title: '글삭제',
        message:
          '삭제된 글은 복구되지 않습니다? \n또한 글에 연결된 댓글도 삭제되므로 확인 후 진행해 주세요 \n정말로 삭제할까요?',
        buttons: [
          {
            label: '삭제',
            onClick: () => {
              this._delF();
            },
          },

          {
            label: '취소',
            //onClick: () => alert('Click No')
          },
        ],
      });
    }
  };
  _delF = async () => {
    const { loginId, history, match } = this.props;
    const idx = match.params.idx;
    if (loginId === null || loginId === undefined || loginId === '') {
    } else {
      const result = await this._delApi(idx);
      //console.log(result)
      const intReturn = result.data[0].intReturn;

      if (intReturn === 0) {
        history.goBack();
      } else {
        alert('admin 또는 작성자만 삭제가 가능합니다.');
      }
    }
  };
  _delApi = (idx) => {
    const { apiUrl, loginId } = this.props;
    return axios
      .post(apiUrl + '/adminBoardDel', {
        params: {
          idx: idx,
          userid: loginId,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert('오류가 발생했습니다.');
      });
  };
  _onLike = async () => {
    const { loginId } = this.props;
    const { likes } = this.state;

    if (loginId === null || loginId === undefined || loginId === '') {
      toast.warn('로그인 후 이용해 주세요.');
      return false;
    } else {
      const result = await this._onLikeApi();
      const intReturn = result.data[0].intReturn;
      if (this._isLoad) {
        if (intReturn === 0) {
          //좋아요 성공
          toast.success('좋아요가 추가되었습니다.');
          this.setState({
            isLike: 100,
            likes: likes + 1,
          });
        } else {
          toast.warn('좋아요가 취소되었습니다.');
          this.setState({
            isLike: 0,
            likes: likes - 1,
          });
          //좋아요 취소
        }
      }
    }
  };
  _onLikeApi = () => {
    const { apiUrl, loginId, match } = this.props;
    const idx = match.params.idx;
    return axios
      .post(apiUrl + '/storeLike', {
        params: {
          idx: idx,
          userid: loginId,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert('오류가 발생했습니다.');
      });
  };
  _onNaver = () => {
    const { match } = this.props;
    const { storeContent } = this.state;
    const store = match.params.store;
    const idx = match.params.idx;
    const title = storeContent[0].title;
    const url = 'http://www.aniplustv.com/storyItem/' + store + '/' + idx;
    window.open(
      'http://share.naver.com/web/shareView.nhn?url=' +
        encodeURIComponent(url) +
        '&title=' +
        encodeURIComponent(title),
      'naversharedialog',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600'
    );
  };
  _onTwitter = () => {
    const { match } = this.props;
    const { storeContent } = this.state;
    const store = match.params.store;
    const idx = match.params.idx;
    const title = storeContent[0].title;
    const url = 'http://www.aniplustv.com/storyItem/' + store + '/' + idx;
    window.open(
      'https://twitter.com/intent/tweet?text=[%EA%B3%B5%EC%9C%A0]%20' +
        encodeURIComponent(url) +
        '%20-%20' +
        encodeURIComponent(title ? title : document.title),
      'twittersharedialog',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600'
    );
  };
  _onFacebook = () => {
    const { match } = this.props;
    const { storeContent } = this.state;
    const store = match.params.store;
    const idx = match.params.idx;
    const title = storeContent[0].title;
    const url = 'http://www.aniplustv.com/storyItem/' + store + '/' + idx;
    window.open(
      'https://www.facebook.com/sharer/sharer.php?u=' +
        encodeURIComponent(url) +
        '&t=' +
        encodeURIComponent(title ? title : document.title),
      'facebooksharedialog',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600'
    );
  };
  _onInstar = () => {
    const { match } = this.props;
    // const { storeContent } = this.state;
    const store = match.params.store;
    const idx = match.params.idx;
    // const title = storeContent[0].title;
    const url = 'http://www.aniplustv.com/storyItem/' + store + '/' + idx;
    window.open(
      'https://plus.google.com/share?url=' + encodeURIComponent(url),
      'googleplussharedialog',
      'menubar=no,toolbar=no,resizable=yes, scrollbars=yes,height=350,width=600'
    );
  };
  _onKakao = () => {
    const { match } = this.props;
    // const { storeContent } = this.state;
    const store = match.params.store;
    const idx = match.params.idx;
    // const title = storeContent[0].title;
    const url = 'http://www.aniplustv.com/storyItem/' + store + '/' + idx;
    window.open(
      'https://story.kakao.com/s/share?url=' + encodeURIComponent(url),
      'kakaostorysharedialog',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes, height=400,width=600'
    );
  };
  render() {
    const { loginId, match, imgUrl } = this.props;
    const { storeContent, edit, isLike, likes } = this.state;

    const idx = match.params.idx;

    /*
        const { match } = this.props;
        const store = match.params.store;
        const idx = match.params.idx;
        */
    return (
      <Fragment>
        {edit ? (
          <StoreEdit
            idx={idx}
            editCancel={this._editCancel}
            editSuccess={this._editSuccess}
          />
        ) : (
          <div className="content">
            <StoreLeftMenu />

            {/*오른쪽 콘텐츠*/}
            <div className="vod_list_right store_right">
              <div className="vod_list_group">
                {storeContent ? (
                  <div className="store_wrap">
                    {/* 스토어 스토리 */}
                    <div className="store_blog">
                      {/* 스토리 상단 */}
                      <div className="blog_top">
                        <h2 className="tit">
                          <button
                            type="button"
                            className="btn_prev"
                            onClick={this._back}
                          >
                            <img
                              src={imgUrl + '/img/store/arrw_pre.svg'}
                              alt="이전"
                            />
                          </button>
                          매장 이야기
                          {loginId === 'admin' ||
                          loginId === 'dlrhrjs33' ||
                          loginId === 'lsy7414' ||
                          loginId === 'dooyu63' ||
                          loginId === 'xwuuwx' ||
                          loginId === 'aji311' ||
                          loginId === 'animi15' ||
                          loginId === 'yoonyg00' ? (
                            <>
                              <button
                                type="button"
                                onClick={this._edit}
                                style={{
                                  position: 'absolute',
                                  top: '48%',
                                  left: 'calc(100% - 40px)',
                                }}
                              >
                                [수정]
                              </button>
                            </>
                          ) : null}
                        </h2>
                        <ul className="post_info">
                          <li className="data">
                            {/* 서울 seoul, 대전 daejeon, 광주 gwangju, 부산 busan / */}
                            <span className="writer busan">
                              {storeContent[0].storeName}{' '}
                            </span>
                            <span className="date">
                              {storeContent[0].writeday}{' '}
                              {storeContent[0].active === false
                                ? ' / 비활성'
                                : null}
                            </span>
                          </li>
                          <li className="social">
                            <ul className="story_social">
                              <li className="story_ico">
                                <span
                                  className={
                                    parseInt(isLike) > 0
                                      ? 'ico_like active'
                                      : 'ico_like'
                                  }
                                  onClick={this._onLike}
                                ></span>
                                <span className="num">{likes}</span>
                              </li>
                              <li className="story_ico">
                                <span className="ico_reply"></span>
                                <span className="num">
                                  {storeContent[0].comment_num}
                                </span>
                              </li>
                              <li className="story_ico">
                                <span className="ico_read"></span>
                                <span className="num">
                                  {storeContent[0].readnum}
                                </span>
                              </li>
                              <li className="story_ico btn_more">
                                <span className="ico_more"></span>
                                <ul className="more_wrap">
                                  <li>
                                    <a
                                      style={{ cursor: 'pointer' }}
                                      onClick={this._onFacebook}
                                    >
                                      <img
                                        src={imgUrl + '/img/store/sns_fb.png'}
                                        alt="페이스북"
                                      />
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      style={{ cursor: 'pointer' }}
                                      onClick={this._onKakao}
                                    >
                                      <img
                                        src={imgUrl + '/img/store/sns_kako.png'}
                                        alt="카카오"
                                      />
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      style={{ cursor: 'pointer' }}
                                      onClick={this._onInstar}
                                    >
                                      <img
                                        src={
                                          imgUrl + '/img/store/sns_google.png'
                                        }
                                        alt="구글"
                                      />
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      style={{ cursor: 'pointer' }}
                                      onClick={this._onTwitter}
                                    >
                                      <img
                                        src={imgUrl + '/img/store/sns_twt.png'}
                                        alt="트위터"
                                      />
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      style={{ cursor: 'pointer' }}
                                      onClick={this._onNaver}
                                    >
                                      <img
                                        src={
                                          imgUrl + '/img/store/sns_naver.png'
                                        }
                                        alt="네이버"
                                      />
                                    </a>
                                  </li>
                                </ul>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </div>
                      {/* 스토리 본문 */}
                      <div className="blog_container">
                        {/* 스토리 내용 */}
                        <div className="blog_content">
                          <h2 className="subject">{storeContent[0].title}</h2>
                          {parse(storeContent[0].content)}
                        </div>
                      </div>
                      {loginId === 'admin' ||
                      loginId === 'dlrhrjs33' ||
                      loginId === 'lsy7414' ||
                      loginId === 'dooyu63' ||
                      loginId === 'xwuuwx' ||
                      loginId === 'aji311' ||
                      loginId === 'animi15' ||
                      loginId === 'yoonyg00' ? (
                        <div onClick={this._del}>[삭제]</div>
                      ) : null}
                      {/* 스토리 이전/다음 */}
                      {/*
                                            <div className="blog_around_post">
                                                <dl>
                                                    <dt>이전</dt>
                                                    <dd>
                                                        <a href="#">인터렉티브 존 룰렛이벤트 첫 시현 감격의 순간 인터렉티브 존</a>
                                                        <span className="date">2022.01.30</span>
                                                    </dd>
                                                </dl>
                                                <dl>
                                                    <dt>다음</dt>
                                                    <dd>
                                                        <a href="#">인터렉티브 존 룰렛이벤트 첫 시현 감격의 순간 인터렉티브 존</a>
                                                        <span className="date">2022.01.30</span>
                                                    </dd>
                                                </dl>
                                            </div>
                                            */}
                      {/* 댓글 */}
                      <StoreComment
                        idx={storeContent[0].idx}
                        isLike={storeContent[0].isLike}
                      />
                    </div>

                    {/* 매장 이야기 */}
                    <StoreList
                      idx={storeContent[0].idx}
                      store={storeContent[0].id}
                    />
                  </div>
                ) : null}
              </div>

              <Footer />
            </div>
            {/* /220109 store */}
            <div className="clear"></div>
          </div>
        )}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(StoryItem)));
